<template>
  <div>
    <!-- Fondo oscuro para el modal intermedio -->
    <div v-show="isVisible" class="overlay-intermediate"></div>

    <!-- Modal de éxito -->
    <md-card v-show="isVisible" class="success-modal" @click.stop>
      <!-- Botón de cierre -->
      <button class="close-btn" @click="closeModal">✕</button>

      <!-- Icono de éxito -->
      <div class="modal-icon">
        <v-icon size="48px" color="green">mdi-check-circle</v-icon>
      </div>

      <!-- Mensaje -->
      <div class="modal-message">
        <p>Recibo enviado con éxito, gracias por confiar en Latino Seguros.</p>
      </div>
    </md-card>
  </div>
</template>

<script>
export default {
  name: "ModalExito",
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    openModal() {
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
/* Capa intermedia para oscurecer el modal de contacto */
.overlay-intermediate {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3); /* Opacidad más tenue */
  z-index: 1015; /* Entre los dos modales */
}

/* Fondo oscuro del modal de éxito */
.success-modal {
  max-width: 280px;
  padding: 20px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 1020; /* Encima de la capa intermedia */
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}

.modal-icon {
  margin-bottom: 20px;
}

.modal-message p {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0;
}
</style>
